import React from 'react';
import { Route, withRouter } from 'react-router-dom';
import {connect} from "react-redux";
import {store} from "../store";
import {SHOULD_LOGIN} from "../actions/actionsTypes";

const mapStateToProps = state => ({ ...state });

class AuthRoute extends React.Component {
    render() {

        const {...restProps } = this.props;

        if (!this.props.auth.authenticated && !this.props.auth.shouldLogin)
            store.dispatch({type: SHOULD_LOGIN});

        return <Route {...restProps} />;
    }
}

export default withRouter(connect(mapStateToProps)(AuthRoute));